import React from "react";
import "./StoryItem.css";
import { Link } from "react-router-dom";
import avatar1 from "../../../assets/images/author.jpg";
import StoryTag from "../../../Common/tag/StoryTag";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaPinterestP,
} from "react-icons/fa";

const StoryItem = ({
  story: {
    _id,
    content,
    title,
    publishingDate,
    user,
    authorAvatar,
    tag,
    thumbnail,
    views = 0,
    likes = 0,
  },
}) => {
  const storyLink = `/story/${_id}`;
  const shareUrl = window.location.href; // URL to be shared
  const shareText = title; // Text for sharing
  // console.log(user.name);
  return (
    <div className="storyitem-container">
      <Link to={storyLink} className="storyitem-wrap-link">
        <div className="storyitem-wrap" onClick={(e) => e.stopPropagation()}>
          {/* Story Thumbnail */}
          <img alt="Story cover" src={thumbnail} className="storyitem-cover" />

          {/* Story Title */}
          <h3 className="story-title">{title}</h3>

          {/* Story Description */}
          <p className="storyitem-desc">{content}</p>

          {/* Story Footer */}
          <footer className="story-footer">
            <div className="storyitem-author">
              {/* Author Avatar */}
              <img src={authorAvatar || avatar1} alt="Author" />
              <div>
                <h6>{user?.name}</h6>
                <p>
                  {(() => {
                    const date = new Date(publishingDate);
                    const day = date.getDate();
                    const monthNames = [
                      "January",
                      "February",
                      "March",
                      "April",
                      "May",
                      "June",
                      "July",
                      "August",
                      "September",
                      "October",
                      "November",
                      "December",
                    ];
                    const month = monthNames[date.getMonth()];
                    const year = date.getFullYear();

                    const getOrdinalSuffix = (day) => {
                      if (day > 3 && day < 21) return "th";
                      switch (day % 10) {
                        case 1:
                          return "st";
                        case 2:
                          return "nd";
                        case 3:
                          return "rd";
                        default:
                          return "th";
                      }
                    };

                    return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
                  })()}
                </p>
              </div>
            </div>
            {/* Engagement metrics */}
            <div className="story-metrics">
              <span title="Views">👁 {views}</span>
              <span title="Likes">❤️ {likes}</span>
            </div>
          </footer>
        </div>
      </Link>
    </div>
  );
};

export default StoryItem;
